<template>
  <div class="create-account">
    <section-header class="mt-5 mb-5" title="建立帳號" subtitle="Create Your Account"/>
    <section class="row justify-content-center pt-5 pb-5">
      <form class="col-lg-6 col-md-8 col-12 needs-validation">
        <div class="row">
          <div class="col-md-6 col-12 mt-3">
            <div class="form-floating">
              <input id="input-last-name" type="text" class="form-control" :class="validation.lastName.class" placeholder="姓氏" maxlength="16" v-model="lastName">
              <label for="input-last-name" class="text-secondary">姓氏</label>
              <div class="invalid-feedback">{{ validation.lastName.feedback }}</div>
            </div>
          </div>
          <div class="col-md-6 col-12 mt-3">
            <div class="form-floating">
              <input id="input-first-name" type="text" class="form-control" :class="validation.firstName.class" placeholder="名字" maxlength="16" v-model="firstName">
              <label for="input-first-name" class="text-secondary">名字</label>
              <div class="invalid-feedback">{{ validation.firstName.feedback }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12 mt-3">
            <div class="form-floating">
              <input id="input-email" type="email" class="form-control" :class="validation.email.class" placeholder="E-mail" maxlength="60" v-model="email">
              <label for="input-email" class="text-secondary">E-mail</label>
              <div class="invalid-feedback">{{ validation.email.feedback }}</div>
            </div>
          </div>
          <div class="col-md-6 col-12 mt-3">
            <div class="form-floating">
              <input id="input-phone" type="tel" class="form-control" :class="validation.mobilePhone.class" placeholder="手機號碼" maxlength="10" v-model="mobilePhone">
              <label for="input-phone" class="text-secondary">手機號碼</label>
              <div class="invalid-feedback">{{ validation.mobilePhone.feedback }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12 mt-3">
            <div class="form-floating">
              <input id="input-passwd" type="password" class="form-control" :class="validation.password.class" placeholder="密碼" maxlength="64" v-model="password">
              <label for="input-passwd" class="text-secondary">密碼</label>
              <div class="invalid-feedback">{{ validation.password.feedback }}</div>
            </div>
          </div>
          <div class="col-md-6 col-12 mt-3">
            <div class="form-floating">
              <input id="input-chkpasswd" type="password" class="form-control" :class="validation.checkPassword.class" placeholder="確認密碼" maxlength="64" v-model="checkPassword">
              <label for="input-chkpasswd" class="text-secondary">確認密碼</label>
              <div class="invalid-feedback">{{ validation.checkPassword.feedback }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-3">
            <div class="form-floating">
              <input id="input-birthday" type="text" class="form-control" :class="validation.birthday.class" placeholder="生日" readonly v-model="birthday">
              <label for="input-birthday" class="text-secondary">生日</label>
              <div class="invalid-feedback">{{ validation.birthday.feedback }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6 col-12 mt-3">
            <button class="btn btn-lg btn-dark w-100" type="button" @click="onSubmitted" :disabled="loading">
              <i v-if="loading" class="spinner-border text-light btn-spinner"></i>
              <span v-else>確認</span>
            </button>
          </div>
          <div class="col-md-6 col-12 mt-3 d-flex align-items-center">
            <span class="text-secondary">已經有帳號了？</span><router-link to="/w/sign-in" class="loft-text-highlight text-decoration-none">登入</router-link>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import authApi from '@/api/auth.js'
import SectionHeader from '@/components/SectionHeader.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'CreateAccount',
  components: {
    SectionHeader
  },
  data: function () {
    return {
      email: null,
      mobilePhone: null,
      firstName: null,
      lastName: null,
      password: null,
      checkPassword: null,
      birthday: null,
      loading: false,
      isValidated: false,
      validation: {
        email: { class: null, feedback: null },
        mobilePhone: { class: null, feedback: null },
        firstName: { class: null, feedback: null },
        lastName: { class: null, feedback: null },
        password: { class: null, feedback: null },
        checkPassword: { class: null, feedback: null },
        birthday: { class: null, feedback: null }
      }
    }
  },
  watch: {
    email: function (value) {
      this.validation.email.class = null
    },
    mobilePhone: function (value) {
      this.validation.mobilePhone.class = null
    },
    firstName: function (value) {
      this.validation.firstName.class = null
    },
    lastName: function (value) {
      this.validation.lastName.class = null
    },
    password: function (value) {
      this.validation.password.class = null
    },
    checkPassword: function (value) {
      this.validation.checkPassword.class = null
    },
    birthday: function (value) {
      this.validation.birthday.class = null
    }
  },
  mounted: function () {
    // init datepicker
    var self = this
    console.log('init datepicker')
    $('#input-birthday').datepicker({
      dateFormat: 'mm/dd',
      yearSuffix: '',
      onSelect: function (date) {
        self.birthday = date
      }
    })
  },
  methods: {
    ...mapMutations([
      'setAlert',
      'setAuthToken'
    ]),
    apiCreateAccount: function () {
      this.loading = true
      var self = this
      var birthdayTm = null
      if (this.birthday) {
        birthdayTm = new Date(`${new Date().getFullYear()}/${this.birthday}`).getTime()
      }
      authApi.createAccount(this.email, this.password, `${this.lastName} ${this.firstName}`, this.firstName, this.lastName, this.mobilePhone, birthdayTm, function (err, rspData) {
        if (err) {
          self.loading = false
          if (err === 2003) {
            self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: '有相似帳號，無法建立帳號' })
            return
          }
          self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: `無法建立帳號：${rspData} (${err})` })
          return
        }
        self.$router.push('/w/verifyTokenMail')
      })
    },
    onSubmitted: function () {
      // input check
      this.isValidated = true
      // check email
      if (!this.email) {
        this.isValidated = false
        this.validation.email.class = 'is-invalid'
        this.validation.email.feedback = '請輸入您的E-mail'
      } else if (!this.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
        this.isValidated = false
        this.validation.email.class = 'is-invalid'
        this.validation.email.feedback = '不正確的E-mail格式'
      } else {
        this.validation.email.class = 'is-valid'
      }
      // check mobile
      if (!this.mobilePhone) {
        this.isValidated = false
        this.validation.mobilePhone.class = 'is-invalid'
        this.validation.mobilePhone.feedback = '請輸入您的手機號碼'
      } else if (!this.mobilePhone.match(/^09\d{8}$/)) {
        this.isValidated = false
        this.validation.mobilePhone.class = 'is-invalid'
        this.validation.mobilePhone.feedback = '不正確的手機號碼格式'
      } else {
        this.validation.mobilePhone.class = 'is-valid'
      }
      // check name
      if (!this.firstName) {
        this.isValidated = false
        this.validation.firstName.class = 'is-invalid'
        this.validation.firstName.feedback = '請輸入您的名字'
      } else {
        this.validation.firstName.class = 'is-valid'
      }
      if (!this.lastName) {
        this.isValidated = false
        this.validation.lastName.class = 'is-invalid'
        this.validation.lastName.feedback = '請輸入您的姓氏'
      } else {
        this.validation.lastName.class = 'is-valid'
      }
      // check password
      if (!this.password) {
        this.isValidated = false
        this.validation.password.class = 'is-invalid'
        this.validation.password.feedback = '請輸入密碼'
      } else if (!(this.password.length >= 8 && this.password.match(/[a-z]/) && this.password.match(/[A-Z]/) && this.password.match(/[0-9]/))) {
        this.isValidated = false
        this.validation.password.class = 'is-invalid'
        this.validation.password.feedback = '密碼需至少8碼，且包含英文大小寫及數字組合'
      } else {
        this.validation.password.class = 'is-valid'
      }
      if (!this.checkPassword) {
        this.isValidated = false
        this.validation.checkPassword.class = 'is-invalid'
        this.validation.checkPassword.feedback = '請再次輸入密碼'
      } else if (this.password !== this.checkPassword) {
        this.isValidated = false
        this.validation.checkPassword.class = 'is-invalid'
        this.validation.checkPassword.feedback = '兩次輸入密碼不相同'
      } else {
        this.validation.checkPassword.class = 'is-valid'
      }
      // check birthday
      if (!this.birthday) {
        this.isValidated = false
        this.validation.birthday.class = 'is-invalid'
        this.validation.birthday.feedback = '請輸入生日'
      } else {
        this.validation.birthday.class = 'is-valid'
      }

      if (!this.isValidated) {
        return
      }

      this.apiCreateAccount()
    }
  }
}
</script>

<style scoped>
.form-control[readonly] {
  background: #fff;
}
</style>
